export const REQUESTING_CLIENT = 'landlord-applications';
